const SPANISH = {
  Drag_the_new_file_to_this_area: 'Arrastre el nuevo archivo a esta área.',
  Drag_images_to_this_area_or_click_on:
    'Arrastre las imágenes a esta área, o presione en',
  Drag_the_image_to_this_area_or_click_on:
    'Arrastre la imagen a esta área, o presione en',
  Drag_the_image_to_this_area_or_press_the_button:
    'Arrastre la imagen a esta área, o presione el botón para cambiarla.',
  Select_the_desired_area_of_the_image_or_click_on:
    'Seleccione el área deseada de la imagen, o presione en',
  Upload_image: 'Subir imagen',
  Upload_images: 'Subir imágenes',
  days: {
    Mondays: 'Los Lunes',
    Tuesdays: 'Los Martes',
    Wednesdays: 'Los Miércoles',
    Thursdays: 'Los Jueves',
    Fridays: 'Los Viernes',
    Saturdays: 'Los Sábados',
    Sundays: 'Los Domingos'
  },
  textLink: {
    Back_to_teams: '← Regresar a la lista de equipos'
  },
  menu: {
    'Add_ons_Store': 'Tienda de Complementos',
    'Avatars': 'Avatares',
    'Clubs': 'Clubs',
    'Competitions': 'Competiciones',
    'Contact': 'Contacto',
    'Can_view': 'Puedo ver',
    'Can_edit': 'Puedo editar',
    'Can_delete': 'Puedo eliminar',
    'Dashboard': 'Tablero',
    'Delegates': 'Delegados',
    'Document_Center': 'Centro de Documentación',
    'Exit': 'Salir',
    'Finance': 'Finanzas',
    'Files': 'Archivos',
    'Fans': 'Aficionados',
    'General_Settings': 'Configuración General',
    'Competition_Manager': 'Administrador de Competiciones',
    'Introduction': 'Introducción',
    'Message_Board': 'Tablero de Mensajes',
    'Members': 'Miembros',
    'Matches': 'Partidos',
    'News': 'Noticias',
    'Organization_Settings': 'Configuración de la Organización',
    'Players': 'Jugadores',
    'Public_Website': 'Sitio web Público',
    'Referee_Officials': 'Árbitros',
    'Responsible_Registration': 'Responsables de Registro',
    'Registration_of_Players': 'Registro de Jugadores',
    'Subscription_&_Billing': 'Suscripción & Facturación',
    'Sites': 'Sitios',
    'Seasons': 'Temporadas',
    'Categories': 'Categorias',
    'Site_Settings': 'Configuración del sitio',
    'Sponsors': 'Patrocinadores',
    'Teams': 'Equipos',
    'Technical_Staff': 'Personal Técnico',
    'Venues': 'Sedes'
  },
  menu_titles: {
    Add_ons: 'Complementos',
    Administration: 'Administración',
    Football_Manager: 'Entrenador de fútbol',
    General_Settings: 'Administración General'
  },
  titles: {
    'System_access': 'Acceso al sistema',
    'Access_for_%s': 'Acceso para %s',
    'Add_a_teams_to_a_division': 'Añadir equipos a una división',
    'Card_Accumulations': 'Acumulaciones de Tarjetas',
    'Create_new_team': 'Crear nuevo equipo',
    'Create_new_division': 'Crear nueva división',
    'Create_new_site': 'Crear nuevo sitio',
    'Create_new_club': 'Crear nuevo club',
    'Create_new_multi_competition_event':
      'Crear nuevo evento multi-competición',
    'Contact': 'Contacto',
    'Clubs': 'Clubs',
    'Club': 'Club',
    'Competition': 'Competición %s',
    'Competitions': 'Competiciones',
    'Competition_Structure': 'Estructura de la Competencia',
    'Contact_Settings': 'Configuración de contacto',
    'Contact_Photos': 'Fotos de contacto',
    'Competition_Duration': 'Duración Competencia',
    'Cycle': 'Ciclo',
    'Division': 'División',
    'Divisions': 'Divisiones',
    'Document_Center': 'Centro de Documentación',
    'Domains': 'Dominios',
    'Duration': 'Duración',
    'Format': 'Formato',
    'Fouls_Accumulation': 'Acumulación de Faltas',
    'Gameplay': 'Juego',
    'Homepage_settings': 'Configuración de la página principal',
    'Horizontal_logo_and_vertical':
      'Logotipo horizontal (desktop/tablet) y vertical (mobile)',
    'Infraction_Cards_Settings': 'Configuración de Tarjetas de infracción',
    'Legal_Guardians_Account': 'Cuenta SPX® de Tutores Legales',
    'Loading': 'Cargando...',
    'Matches': 'Partidos',
    'Members': 'Miembros',
    'Manage_Entities': 'Manejo de Entidades',
    'Manage_Competitions': 'Manejo de las Competiciones',
    'Multi_Competition_Events': 'Eventos Multi-Competición',
    'News': 'Noticias',
    'New_competition_Competition_Settings':
      'Nueva competencia - Ajustes de Competencia',
    'New_competition_Playoffs_Phase_Settings':
      'Nueva competencia - Ajustes de Fase Eliminatoria',
    'New_competition_Regular_Phase_Settings':
      'Nueva competencia - Ajustes de Fase Regular',
    'New_competition_General_Competition_Information':
      'Nueva competencia - Informacion general de competencia',
    'Optional_Information': 'Información Opcional',
    'Organization_Settings': 'Configuración de la Organización',
    'Personal_Information': 'Información Personal',
    'Parental_Control': 'Control Parental',
    'Players': 'Jugadores',
    'Players_on_field': 'Jugadores en el campo',
    'Players_on_bench': 'Jugadores en banca',
    'Personal': 'Personal',
    'Registration_Period': 'Periodo de Registro',
    'Remove_technical_staff': 'Eliminar personal técnico',
    'Points_per_result': 'Puntos por resultado',
    'Public_Website': 'Sitio web Público',
    'Quick_View': 'Vista rápida',
    'Remove_player': 'Eliminar jugador',
    'Sites': 'Sitios',
    'Services_provided': 'Servicios ofrecidos',
    'Social_Networks': 'Redes sociales',
    'Substitutions': 'Sustituciones',
    'Site_Customization': 'Personalización del sitio',
    'Statistics_generation': 'Generación de estadísticas',
    'Team': 'Equipo',
    'Team_Name': 'Equipo %s',
    'Teams': 'Equipos',
    'Team_Roster_Player_Limit': 'Límite de jugadores del equipo en lista',
    'Teams_in_competition': 'Equipos en la competencia',
    'Technical_Staff': 'Personal Técnico',
    'Update_statistics_seasons': 'Actualizar estadísticas de temporadas',
    'Yellow_Card_Accumulation': 'Acumulación de Tarjetas Amarillas',
    'Yellow_Cards_Blue_Cards_per_1_Red_Card':
      'Tarjetas Amarillas + Tarjetas Azules para 1 Tarjeta Roja'
  },
  labels: {
    '%s_red_card_timeout': '%s tiempo de espera de la tarjeta roja',
    '%s_yellow_card_timeout': '%s tiempo de espera de la tarjeta amarilla',
    '%s_blue_card_timeout': '%s tiempo de espera de la tarjeta azul',
    'Ad_location': 'Ubicación del anuncio',
    'Amount_of_teams_per_group': 'Cantidad de equipos por grupo',
    'Amount_of_starting_players': 'Cantidad de jugadores iniciales',
    'Avatar': 'Avatar',
    'Assign_teams': 'Asignar equipos',
    'Age_older_than': 'Edad mayor de',
    'Age_younger_than': 'Edad menor de',
    'Birthdate': 'Fecha de nacimiento',
    'Blue_cards': 'Tarjetas azules',
    'Blue_cards_for_1_red_card': 'Tarjetas azules para 1 tarjeta roja',
    'Category': 'Categoría',
    'Organization': 'Organización',
    'Criteria': 'Criterios',
    'Contact_phone': 'Teléfono de contacto',
    'Contact_E-Mail': 'Correo electrónico de contacto',
    'Content': 'Contenido',
    'Configuration': 'Configuración',
    'Cover_Image': 'Imagen de Portada',
    'Competition_opening_date': 'Fecha de apertura de competencia',
    'Competition_closing_date': 'Fecha de cierre de la competencia',
    'Day': 'Día',
    'Date_of_birth': 'Fecha de nacimiento',
    'Description': 'Descripción',
    'Desktop_image': 'Imagen en computadoras de escritorio (',
    'Destiny_league': 'Liga de destino',
    'Division': 'División',
    'Division(s)': 'División (es)',
    'Domain': 'Dominio',
    'Download': 'Descargar',
    'Email': 'Correo electrónico',
    'EMAIL': 'CORREO ELECTRÓNICO',
    'Email_address': 'Dirección de correo electrónico',
    'Family_name(s)': 'Apellido(s)',
    'First_Name': 'Nombre',
    'First_name(s)': 'Nombre(s)',
    'First_background_color': 'Color 1 del fondo',
    'File': 'Archivo',
    'File_status': 'Estado del archivo',
    'Format': 'Formato',
    'Gameplay': 'Juego',
    'Given_name(s)': 'Nombre dado(s)',
    'Gender': 'Género',
    'Goals_for_winner': 'Objetivos para el ganador',
    'Half_time_duration': 'Duración del medio tiempo',
    'How_many_teams_advance_to_playoffs?':
      '¿Cuántos equipos avanzan a eliminatorias?',
    'Icon': 'Icono',
    'Image_tablets': 'Imagen en tablets (',
    'Image_on_mobile_devices': 'Imagen en dispositivos moviles (',
    'Jersey_number_and_positions': 'Número y posiciones',
    'Jersey_number': 'Número de camiseta',
    'Last_Name': 'Apellidos',
    'Legal_guardian_contact': 'Contacto del padre o tutor',
    'Limit_of_players_on_bench': 'Límite de jugadores en banca',
    'Logo_Horizontal': 'Logotipo Horizontal',
    'Logo_Vertical': 'Logotipo Vertical',
    'Logo': 'Logotipo',
    'Match_structure': 'Estructura de partido',
    'Member_name': 'Nombre de miembro',
    'Month': 'Mes',
    'Mobile_phone': 'Teléfono móvil',
    'Mobile': 'Móvil',
    'Mobile_number': 'Número de teléfono móvil',
    'Multi_Competition_Events': 'Eventos Multi-Competición',
    'Minutes': 'Minutos',
    'Minimum_amount_of_players_on_the_field':
      'Cantidad mínima de jugadores en el campo',
    'Name': 'Nombre',
    'Nationality': 'Nacionalidad',
    'News_status': 'Estado de las noticias',
    'Nickname': 'Apodo',
    'Number_of_penalty_kicks': 'Número de penaltis',
    'Number_of_periods': 'Número de períodos',
    'Number_of_yellow_Cards': 'Número de tarjetas amarillas',
    'Number_of_matches_suspended': 'Número de partidos suspendidos',
    'Number_of_cycles': 'Número de ciclos',
    '(Optional)': '(Opcional)',
    'Overtime': '"Tiempo extra"',
    'Owner': 'Propietario',
    'Office_address': 'Dirección de las oficinas',
    'Password': 'Contraseña',
    'Period_duration': 'Duración del período',
    'Periodicity': 'Periodicidad',
    'Position(s)': 'Posción(es)',
    'Positions': 'Posiciones (elige hasta 3 posiciones)',
    'Points_per_win': 'Puntos por victoria',
    'Points_per_draw': 'Puntos por empate',
    'Points_per_lost': 'Puntos por perdida',
    'Points_for_winner': 'Puntos para el ganador',
    'Pic': 'Foto',
    'Photo': 'Foto',
    'for': ' por ',
    'Primary_color': 'Color primario',
    'Permissions': 'Permisos',
    'Penalty_kicks': 'Penales',
    'Page_Title': 'Título de la Página',
    'Page_Description': 'Descripción de Página',
    'Player_limit': 'Límite de jugadores',
    'player_is_underage_You_must_attach_an_official_document':
      'El jugador es menor de edad. Debe adjuntar un documento oficial con una fotografía del padre o tutor.',
    'Query_Google_Maps_for_map': 'Query de Google Maps para el mapa',
    'Referee_Body': 'Cuerpo de árbitros',
    'Role': 'Puesto',
    'Rounds': 'Rondas',
    'Rule %s': '%s Regla',
    'Reinforcements_limit': 'Límite de refuerzos',
    'Reinforcement_criteria': 'Criterios de refuerzo',
    'Registration_opening_date': 'Registro de fecha de apertura',
    'Registration_closing_date': 'Registro de fecha de cierre',
    'Shortname': 'Nombre corto',
    'Sex': 'Sexo',
    'Season': 'Temporada',
    'Second_background_color': 'Color 2 del fondo',
    'Statistics_generation': 'Generación de estadísticas',
    'Search_for_players_by_name_email_or_mobile_number':
      'Buscar jugadores por nombre, correo electrónico o número de teléfono móvil',
    'Search_for_technical_staff_by_name_email_or_mobile_number':
      'Búsqueda de personal técnico por nombre, correo electrónico o número de teléfono móvil',
    'Select_teams_to_add': 'Seleccionar equipos para agregar',
    'Site_status': 'Estado del Sitio',
    'Suspensions_applies_to': 'Suspensiones aplicadas a',
    'Type': 'Tipo',
    'Title': 'Título',
    'Tags': 'Etiquetas',
    'Teams': 'Equipos',
    'Time_of_first_match': 'Hora del primer partido',
    'Time_of_last_match': 'Hora del último partido',
    'Third_background_color': 'Color 3 del fondo',
    'Venues': 'Sedes',
    'Year': 'Año',
    'You_do_not_have_an_account': '¿No tienes una cuenta?',
    'Yellow_cards_for_1_red_card': 'Tarjetas amarillas para 1 tarjeta roja',
    'Yellow_cards': 'Tarjetas amarillas',
    'Location': 'Ubicación'
  },
  placeholders: {
    'Search_SportsProX': 'Buscar SportsProX®',
    'Search_term': 'Término de busqueda',
    'Search': 'Buscar',
    'type_a_new_tag': 'escriba una nueva etiqueta',
    'YYYY-mm-dd': 'AAAA-mm-dd'
  },
  buttons: {
    Add: 'Agregar',
    Add_team: 'Agregar equipo',
    Add_teams: 'Agregar equipos',
    Add_division: 'Agregar división',
    Add_competition: 'Agregar competencia',
    Add_manually: 'Agregar manualmente',
    Add_player: 'Agregar jugador',
    Add_multi_competition_event: 'Agregar evento multi-competición',
    Cancel: 'Cancelar',
    Community: 'Comunidad',
    Create_team: 'Crear equipo',
    Create_site: 'Crear un sitio',
    Create_news: 'Crear noticia',
    Create_account: 'Crear cuenta',
    Create_file: 'Crear archivo',
    Create_club: 'Crear club',
    Create_Division: 'Crear División',
    Create_event: 'Crear evento',
    Close: 'Cerrar',
    delegates: 'delegados',
    Exit_Settings_Panel: 'Salir del Panel de Ajustes',
    Edit_Access: 'Editar Acceso',
    Edit: 'Editar',
    Filters: 'Filtros',
    Invite: 'Invitar',
    Invite_player: 'Invitar jugador',
    Invite_players: 'Invitar jugadores',
    Invite_members: 'Invitar miembros',
    Invite_technical_staff: 'Invitar personal técnico',
    Import: 'Importar',
    Login: 'Entrar',
    Network: 'Red',
    Next: 'Siguiente',
    New_site: 'Nuevo sitio',
    Open_full_profile: 'Ver perfil',
    Open_Competition: 'Ver competición',
    players: 'jugadores',
    Previous: 'Anterior',
    Remove: 'Eliminar',
    Remove_collaborator: 'Eliminar colaborador',
    Restore: 'Restaurar',
    Save: 'Guardar',
    Select_another_file: 'Seleccionar otro archivo',
    Save_access_settings: 'Guardar configuración de acceso',
    Select_File: 'Seleccionar archivo',
    teams: 'equipos',
    technical_staff: 'cuerpo técnico',
    Update_all: 'Actualizar todas',
    Update: 'Actualizar',
    Upload_ads: 'Subir anuncios',
    OpenFullProfile: 'Ver perfil'
  },
  radio_buttons: {
    Female: 'Mujer',
    Male: 'Hombre'
  },
  roles: {
    Admin: 'Administrador',
    Attacking_Midfielder: 'Media Ofensiva',
    Forward: 'Delantera',
    Collaborator: 'Colaborador',
    Center_Midfielder: 'Defensa Central',
    Defensive_Midfielder: 'Media de Conteción',
    Football: 'Fútbol',
    Goalkeeper: 'Portería',
    Owner: 'Propietario',
    Side_Midfielder: 'Media por los Costados',
    Side_midfielder: 'Media por los costados',
    Side_Back: 'Defensa Lateral',
    technical_staff: {
      TECHNICAL_DIRECTOR: 'DIRECTOR TÉCNICO',
      TECHNICAL_ASSISTANT: 'ASISTENTE TÉCNICO',
      DOCTOR: 'DOCTOR',
      PHYSICAL_TRAINER: 'ENTRENADOR FÍSICO',
      GOALKEEPER_TRAINER: 'PORTERO ENTRENADOR',
      PHYSIOTHERAPIST_KINESIOLOGIST: 'FISIOTERAPEUTA KINESIÓLOGO',
      UTILIER: 'FUTBOLISTA',
      DELEGATE: 'DELEGADO'
    }
  },
  modal_headers: {
    ATTACHMENTS: 'ARCHIVOS ADJUNTOS',
    Add_new_player: 'Agregar nuevo jugador',
    Add_new_technical_staff: 'Añadir nuevo personal técnico',
    Add_file: 'Agregar archivo',
    Create_news: 'Crear noticia',
    Edit_player: 'Editar jugador',
    Edit_technical_staff: 'Editar personal técnico',
    Edit_news: 'Editar noticia',
    Edit_Website: 'Editar Sitio Web',
    Edit_file: 'Editar archivo',
    Invite_member: 'Invitar miembro',
    Invite_a_new_member: 'Invitar a un nuevo miembro',
    Invite_Technical_Staff: 'Invitar Personal Técnico',
    Uploading_files: 'Subiendo archivos...',
    Uploading_images: 'Subiendo imagenes...',
    Updating_statistics: 'Actualizando estadísticas'
  },
  validations: {
    An_unknown_error_occurred:
      'Se produjo un error desconocido, por favor intente de nuevo más tarde. Si el problema persiste, póngase en contacto con el administrador.',
    Authentication_error: 'Error de autenticación',
    Account_already_exists:
      'La cuenta ya existe. Intente entrar con su cuenta existente.',
    email_or_password_invalid: 'El correo y/o password no son válidos.',
    data_were_incorrect: 'Los datos no son correctos',
    Error: 'Error',
    invalid_email: 'El correo no es válido.',
    It_happened_a_problem: '(Sucedio un problema, por favor ponganse en contacto con el equipo de RefereePro)',
    Invalid: 'Inválido',
    It_seems_a_problem_has_occurred_during_the_processing: 'Parece que ha ocurrido un problema durante el procesamiento de los datos presentados.',
    Internal_Server_Error: 'Error del Servidor Interno',
    password_min_length: 'La clave debe de tener al menos %s caracteres.',
    Page_not_found: 'Página no encontrada',
    phone_number_is_invalid: 'El número de teléfono no es válido.',
    number_is_invalid: 'El número no es válido.',
    not_authenticated:
      'No está autenticado o la sesión ha finalizado. Por favor inicie sesión e intente de nuevo.',
    Please_contact_the_administrator:
      'Por favor, póngase en contacto con el administrador.',
    review_fields_are_correct:
      'Revise por favor que los campos tengan los valores correctos.',
    Required: '* Requerido',
    Three_maximum: '(Máximo tres)',
    The_server_did_not_respond:
      'El servidor no responde con la respuesta esperada, por favor intente de nuevo más tarde. Si el problema persiste, póngase en contacto con el administrador.',
    The_requested_page_does_not_exists:
      'La página solicitada no existe. Por favor, póngase en contacto con el administrador.',
    unknow_error:
      'Error desconocido, por favor contacte al administrador si el problema persiste.',
    Unknown_error: 'Error desconocido',
    Validation_error: 'Error de validacion'
  },
  descriptions: {
    Are_you_sure_you_want_to_remove_from_this_team:
      '¿Seguro que desea eliminar %s de este equipo?'
  },
  for_check: {
    'Allow_re-entry?': '¿Permitirá el reingreso?',
    'Assitant_referee_%s': 'Árbitro asistente %s',
    'Assistant_referee_signals': 'Señales de los árbitros asistentes',
    'Add_ons_Store': 'Tienda de Complementos',
    'Clubs': 'Clubs',
    'Custom_order': 'Orden personalizado',
    '"Contact"_section': 'Sección "Documentos"',
    'Competitions': 'Competiciones',
    'Competition_Statistics': 'Estadísticas de la Competición',
    '"Documents"_section': 'Sección "Documentos"',
    'Divisions': 'Divisiones',
    'Enable_Pause_timer_in_REF!': 'Habilitar "Pausa" en temporizador REF!',
    'Fourth_official': 'Cuarto árbitro',
    'General_Information': 'Información General',
    'General_Settings': 'Configuración General',
    '"Home Page"_section': 'Sección "Página"',
    'Include_the_use_of_Blue_Card': 'Incluir el uso de la Tarjeta Azul',
    'Members': 'Miembros',
    'Match_Reports': 'Reporte de partidos',
    '"News"_section': 'Sección "Noticias"',
    'Parental_Control': 'Control Parental',
    'Players': 'Jugadores',
    'Player_Categories': 'Categorías Jugador',
    'Principal_referee': 'Árbitro principal',
    'Promotions': 'Promociones',
    'Reset_count_every_period?': '¿Restaurar contador de cada periodo?',
    'Subscription_&_Billing': 'Suscripción & Facturación',
    'Show_contact_invitation': 'Mostrar invitación a contácto',
    'Show_display_search_teams_and_players':
      'Mostrar buscador de equipos y jugadores',
    'Show_gallery_Instagram': 'Mostrar galería de Instagram',
    'Show_stats_team_lost_MAN':
      'Mostrar estadísticas de equipos que mán perdido',
    'Show_statistics_show_more_goals_against':
      'Mostrar estadísticas de más goles recibidos',
    'Show_general_statistics_for_own_goals':
      'Mostrar estadísticas generales de autogoles',
    'Set_count_fouls_accumulation':
      'Recuento de conjunto de acumulación de faltas',
    'Set_yellow_card_accumulation':
      'Acumulación de conjunto de tarjetas amarillas',
    'Set_a_registration_period': 'Establecer un período de registro',
    'Set_a_substitutions_limit': 'Establecer límite de sustituciones',
    'Set_a_player_limit': 'Establecer límite de jugadores',
    'Teams': 'Equipos',
    'Team_Delegates': 'Equipo de Delegados',
    'Technical_Staff': 'Personal Técnico',
    'Team_Rosters': 'Listas de Equipo',
    'Timekeeper_referee': 'Árbitro cronometrador',
    'Tolerance_reduction_cycles': 'Ciclos de reducción de la tolerancia',
    'Use_custom_background': 'Usar fondo personalizado'
  },
  social_media: {
    Facebook: 'Facebook',
    Instagram: 'Instagram',
    Twitter: 'Twitter',
    YouTube: 'YouTube'
  },
  select_item: {
    '%s periods': '%s periodos',
    'Mayor': 'Mayor',
    'Active': 'Activo',
    'All': 'Todas',
    'At_all_matches': 'En todos los partidos',
    'Automatic': 'Automático',
    'An_additional_match': 'Partido adicional',
    'Apply_to_championship_phase?': '¿Aplicar a la fase de campeonato?',
    'Best_matches': 'Mejores partidos',
    'Custom': 'Personalizado',
    'Championship_phase': 'Fase del campeonato',
    'Draft': 'Borrador',
    'Deleted_(WARNING)': 'Eliminado (ADVERTENCIA)',
    'Direct_match_results': 'Resultados de los partidos directos',
    'Division_A': 'División A',
    'Division_B': 'División B',
    'Every_mid_season': 'Cada mitad de la temporada',
    'Every_season': 'Cada temporada',
    'Every_two_seasons': 'Cada dos temporadas',
    'FANS_Stats': 'FANS Estadísticas',
    'Football_7': 'Fútbol 7',
    'Final_phase': 'Fase final',
    'Global_score': 'Puntuación global',
    'Global_score_with_away_goals': 'Puntuación global con goles de visitante',
    'Groups': 'Grupos',
    'Group_phase': 'Fase de grupos',
    'Goals_difference': 'Diferencia de goles',
    'Goals_in_favor': 'Goles a favor',
    'Goals_against': 'Goles en contra',
    'Inactive': 'Inactivo',
    'Just_the_series': 'Sólo las series',
    'Manual': 'Manual',
    'Mandatory_winner': 'Ganador obligatorio',
    'Mini_Football': 'Mini Fútbol',
    'Not_set': 'No establecido',
    'Off': 'Apagado',
    'One_round': 'Una vuelta',
    'Overtime_and/or_penalty_kicks': 'Tiempo extra y / o penales',
    'Only_as_tie_breaker': 'Solamente desempate',
    'Only_a_regular_phase': 'Sólo una fase regular',
    'Only_playoffs_phase': 'Sólo fase de eliminatoria',
    'Only_regular_phase': 'Sólo fase regular',
    'Published': 'Publicado',
    'Playoffs_phase': 'Fase de eliminatoria',
    'Players_older_than': 'Jugadores mayores de ...',
    'Players_younger_than': 'Jugadores más jóvenes que ...',
    'Private': 'Privado',
    'Principal': 'Principal',
    'Positions_table': 'Tabla de posiciones',
    'Random': 'Aleatorio',
    'Regular_phase_Playoffs_phase': 'Fase regular + Fase eliminatoria',
    'Regular_phase_Two_playoffs_phase': 'Fase regular + Dos eliminatorias',
    'Regular_phase_All_playoffs_phases':
      'Fase regular + Todas las fases de eliminatoria',
    'Setup': 'Configuración',
    'Select_a_periodicity': 'Seleccione periodicidad',
    'Select_an_option': 'Seleccione una opción',
    'Select_a_criteria': 'Seleccione un criterio',
    'Select_a_division': 'Seleccione una división',
    'Specific_divisions': 'Divisiones específicas ...',
    'Select_a_gameplay': 'Seleccionar un modo de juego',
    'Select_the_number_of_periods': 'Seleccione el número de períodos',
    'Select_a_rule': 'Seleccione una regla',
    'Select_a_preset': 'Seleccionar un valor preestablecido',
    'Soccer': 'Fútbol',
    'Select_a_configuration': 'Seleccione una configuración',
    'Select_a_suspension_rule': 'Seleccione una regla de suspensión',
    'Select_rounds': 'Seleccione rondas',
    'Select_a_format': 'Seleccione un formato',
    'Select_criteria': 'Seleccione los criterios',
    'Side_menu': 'Menú lateral',
    'Two_rounds_(home & away matches)':
      'Dos rondas (en casa & partidos fuera de casa)',
    'Minor': 'Menor',
    'Venue_A': 'Sede A',
    'Venue_B': 'Sede B',
    'Venue_C': 'Sede C',
    'Venue_D': 'Sede D',
    'Medium': 'Mediano'
  },
  empty_descriptions: {
    No_news: 'No hay noticias'
  },
  dynamic_fields: {
    weight: "Peso",
    curp: "CURP",
    rfc: "RFC"
  },
  'Age Status': 'Estatus / Edad',
  'Player_Archive': 'Archivos del jugador',
  'No_files_stored': 'No hay archivos guardados.',
  'Upload files': 'Subir archivos',
  OldPlayerFormModal: {
    players_limit: "No es posible agregar a un jugador adicional ya que se alcanzó el límite de jugadores permitidos.",
    register_season_closed: "La temporada de registro esta cerrada."
  },
  Team: {
    "Limit_Reached": "Se alcanzó el límite de jugadores permitido para los equipos en esta competición."
  },
  technical: {
    "Remove from team": "Eliminar jugador",
    "Staff Type": "Puesto"
  }
}

export default SPANISH
